import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type GridColumns = 2 | 3 | 4 | 5 | 6;

interface GridSettingsContextType {
  columns: GridColumns;
  setColumns: (columns: GridColumns) => void;
}

const GridSettingsContext = createContext<GridSettingsContextType | undefined>(undefined);

const STORAGE_KEY = 'catalog-grid-columns';

export function GridSettingsProvider({ children }: { children: ReactNode }) {
  const [columns, setColumnsState] = useState<GridColumns>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? (parseInt(stored) as GridColumns) : 6;
  });

  const setColumns = (newColumns: GridColumns) => {
    setColumnsState(newColumns);
    localStorage.setItem(STORAGE_KEY, String(newColumns));
  };

  return (
    <GridSettingsContext.Provider value={{ columns, setColumns }}>
      {children}
    </GridSettingsContext.Provider>
  );
}

export function useGridSettings() {
  const context = useContext(GridSettingsContext);
  if (!context) {
    throw new Error('useGridSettings must be used within a GridSettingsProvider');
  }
  return context;
}
